import { list } from '@wix/ambassador-identity-members-groups-v1-group-info/http';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { ControllerFlowAPI, IHttpClient } from '@wix/yoshi-flow-editor';
import { isTruthy } from '../utils/isTruthy';

type ErrorHandler = ControllerFlowAPI['errorHandler'];

export interface GroupsApi {
  getMissingPlanIds(pageId: string): Promise<string[]>;
}

export class GroupsService implements GroupsApi {
  constructor(private httpClient: IHttpClient) {}

  public async getMissingPlanIds(pageId: string) {
    const response = await this.httpClient.request(
      list({
        type: 'plan',
        resourceId: pageId,
      }),
    );
    const { groups = [] } = response.data;
    return groups.map((group) => group.id).filter(isTruthy);
  }
}

export class GroupsServiceWithErrorHandler implements GroupsApi {
  constructor(private httpClient: IHttpClient, private errorHandler: ErrorHandler) {}

  public async getMissingPlanIds(pageId: string) {
    const response = await this.errorHandler.withErrorHandler(
      () =>
        this.httpClient.request(
          list({
            type: 'plan',
            resourceId: pageId,
          }),
        ),
      { errorCodesMap: {} },
    );
    const { groups = [] } = response.data;
    return groups.map((group) => group.id).filter(isTruthy);
  }
}

export function createGroupsApi(flowAPI: ControllerFlowAPI) {
  const isErrorHandlerEnabled = flowAPI.experiments.enabled(TPA_EXPERIMENTS.ERROR_HANDLER_TPA);

  if (isErrorHandlerEnabled) {
    return new GroupsServiceWithErrorHandler(flowAPI.httpClient, flowAPI.errorHandler);
  }
  return new GroupsService(flowAPI.httpClient);
}
